<template>
    <a v-if="!inKidMode" href @click.prevent="onClick" class="link">
        <div class="icon"><span class="fa fa-smile"></span></div>
        <div class="text">Enter Kid Mode</div>
    </a>
</template>

<script>

export default {

    props: [ 'inKidMode' ],

    computed: {

    },

    methods: {

        onClick() {
            this.$root.$emit('kid-mode-modal');
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/KidModeMenuButton.vue